import { render, staticRenderFns } from "./import.vue?vue&type=template&id=39a3fece&scoped=true&"
import script from "./import.vue?vue&type=script&lang=js&"
export * from "./import.vue?vue&type=script&lang=js&"
import style0 from "./import.vue?vue&type=style&index=0&id=39a3fece&prod&lang=scss&scoped=true&"
import style1 from "./import.vue?vue&type=style&index=1&id=39a3fece&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a3fece",
  null
  
)

export default component.exports